import 'core-js/features/iterator';
import 'core-js/es/symbol';

import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'pcln-design-system';

import Newsletter from '../components/Newsletter';
import AppBanner from '../components/AppBanner';
import TrackingPixel from '../components/TrackingPixel';
import UAParser from 'ua-parser-js';
import DatePicker from 'components/DatePicker/Priceline.js';
import ReviewsContainer from 'components/Review/ReviewsContainer';
import GDPRCookieBanner from '../components/GDPRCookieBanner';

/**
 * React render function that hydrates a component
 *
 * @param {React.Component}        Component The component to hydrate
 * @param {HTMLCollection|Element} element   An element or a collection of elements to render the component to
 * @param {boolean}                parent    If true, the component will render to the parent element of element
 */
const render = (Component, element, parent = false) => {
    if (element) {
        const render = (el, props) => {
            ReactDOM.render(
                <ThemeProvider>
                    <Component {...props} />
                </ThemeProvider>,
                el
            );
        };

        if (element instanceof HTMLCollection) {
            for (let index = element.length - 1; index >= 0; index--) {
                const el = element[index];
                const props = el.dataset.props ? JSON.parse(el.dataset.props) : {};
                props.isClient = true;
                render(parent ? el.parentNode : el, props);
            }
        } else {
            const props = element.dataset.props ? JSON.parse(element.dataset.props) : {};
            render(parent ? element.parentNode : element, props);
        }
    }
};

/**
 * Fixes the history method for ie.
 * This fixes the 'undefined' being appended to the end of the url in IE11/Edge
 *
 * @see https://github.com/vuejs/vue-router/issues/2023#issuecomment-364156931
 *
 * @param {string} name
 */
const fixHistoryMethod = name => {
    const oldMethod = window.history[name];
    window.history[name] = (state, title, url) => {
        /* eslint-disable no-undefined */
        if (url === undefined) {
            /* eslint-enable no-undefined */
            oldMethod.apply(window.history, [
                state,
                title
            ]);
        } else {
            oldMethod.apply(window.history, [
                state,
                title,
                url
            ]);
        }
    };
};

fixHistoryMethod('replaceState');
fixHistoryMethod('pushState');

const load = setInterval(() => {
    if (window.__READY__) {
        clearInterval(load);

        render(DatePicker, document.getElementsByClassName('pcln-date-picker'), true);
        render(AppBanner, document.getElementById('appBanner'));
        render(TrackingPixel, document.getElementById('tracking-pixel'));
        render(Newsletter, document.getElementsByClassName('newsletter-container'), true);
        render(ReviewsContainer, document.getElementsByClassName('reviewsContainer'));
        render(GDPRCookieBanner, document.getElementById('cookieBanner'));

        /**
         * Listens for on focus event for the auto suggest input field. If it's a mobile device, scroll up so the input field is at the top of the screen
         */
        if (typeof window !== 'undefined' && new UAParser(window.navigator.userAgent).getDevice().type === 'mobile') {

            /**
             * Loop through the parent elements and add an event listener to scroll to top
             */
            const inputElements = document.getElementsByClassName('auto-suggest-input');
            for (let index = inputElements.length - 1; index >= 0; index--) {
                inputElements[index].addEventListener('focus', () => {
                    inputElements[index].scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                });
            }
        }
    }
}, 10);
